export const LOCAL_STORAGE_PREFIX = "feature-flag:";
